import axios from "axios";
import { AppointmentClientState } from "../../../types/pages/AppointmentClient";
import { config } from "../../../Constants";
import { getAuthTokenConfig } from "../../../helpers/others/getAuthTokenConfig";

type Payload = Pick<AppointmentClientState, "searchText" | "skip" | "limit"> & { tenantId?: number}

export const fetchAppointmentClients = async(payload: Payload) => {

    const { tenantId, searchText, skip, limit } = payload;

    const param = `searchText=${searchText}&skip=${skip}&limit=${limit}`;
    
    const endpoint = `${config.url.BACKEND_API_URL}/clients/${tenantId}/appointment-clients?${param}`;
    const authConfig = getAuthTokenConfig();
  
    const response = await axios.get(endpoint, authConfig);
    return response.data;

}